export default __webpack_public_path__ + "static/media/Strugani 8.79e4b77c.jpg";